import { get, post, put } from './http-calls';

export const getVehicleInspectionsStatusList = async (data) => {
    let res = await get(`VehicleInspection/VehicleInspection_GetStatus`, { useAuthToken: true });
    return res;
};

// export const addUpdateVorReason = async (data) => {
//     let res = await post(`VOR/VORReasons`, data, { useAuthToken: true });
//     return res;
// };
